import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './app/store'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './index.css'
import { BrowserRouter as Router } from 'react-router-dom'
import { ChakraProvider } from '@chakra-ui/react'
import { theme } from 'Core'
import { royTheme } from 'Core/Styles/theme'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import { CacheProvider } from '@emotion/react'
const container = document.getElementById('root')!
const root = createRoot(container)
import createCache from '@emotion/cache'
const persistor = persistStore(store)

function MyEmotionProvider({ nonce, children }: { nonce: string; children: React.ReactNode }) {
  const cache = createCache({ nonce: nonce, key: nonce })
  return <CacheProvider value={cache}>{children}</CacheProvider>
}

root.render(
  // <React.StrictMode>
  <MyEmotionProvider nonce='bbbdbadfcdbafaffdsasabfcddccdbfafddb'>
    <ChakraProvider resetCSS theme={royTheme}>
      <Provider store={store}>
        <Router>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </Router>
      </Provider>
    </ChakraProvider>
  </MyEmotionProvider>,
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
